module.exports = __webpack_public_path__ + "static/img/9.7ad98ea.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/zh/9.png
// module id = qY7y
// module chunks = 0